/**
 * @fileoverview
 * Error Interceptor - Handles HTTP errors globally
 *
 * @version 1.0.0
 * @author KATALYST TEAM
 */

import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { TokenService } from '../services/token.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const tokenService = inject(TokenService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage = 'An error occurred';
      let errorCode: string | undefined;
      let errorDetails: any = null;

      if (error.error?.message) {
        errorMessage = Array.isArray(error.error.message)
          ? error.error.message.join(', ')
          : error.error.message;
        errorCode = error.error?.error?.code;
        errorDetails = error.error?.error?.details;
      } else if (error.message) {
        errorMessage = error.message;
      }

      switch (error.status) {
        case 401: {
          tokenService.removeTokens();

          if (!router.url.startsWith('/auth/login')) {
            router.navigate(['/auth/login']);
          }

          break;
        }

        case 403:
          console.error('Forbidden:', errorMessage);
          break;

        case 404:
          console.error('Resource not found:', errorMessage);
          break;

        case 422:
          console.error('Validation error:', errorMessage, errorDetails);
          break;

        case 409:
          console.error('Conflict:', errorMessage);
          break;

        case 500:
        case 502:
        case 503:
        case 504:
          console.error('Server error:', errorMessage);
          break;

        case 0:
          errorMessage = 'Network error - please check your connection';
          console.error(errorMessage);
          break;

        default:
          console.error('HTTP Error:', errorMessage, error);
      }

      const enhancedError = {
        ...error,
        errorMessage,
        errorCode,
        errorDetails,
      };

      return throwError(() => enhancedError);
    })
  );
};
